var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"title":_vm.$t('synchronization.stop_warning'),"visible":_vm.isOpened,"ok-text":_vm.$t('common.stop'),"ok-button-props":{
    props: {
      type: 'danger',
      loading: _setup.stopRequest,
      disabled: !_setup.stopConfirmationValueIsValid
    }
  }},on:{"ok":_setup.handleStopSync,"cancel":_setup.handleCancel}},[_c('div',{staticClass:"popover-body__input"},[_c('a-input',{attrs:{"placeholder":_vm.$t('common.enter_text')},model:{value:(_setup.stopConfirmationValue),callback:function ($$v) {_setup.stopConfirmationValue=$$v},expression:"stopConfirmationValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }